// import React from "react";
// import {
//   MapPin,
//   Gauge,
//   ShieldCheck,
//   SettingsAutomation,
//   BuildingStorefront,
// } from "tabler-icons-react";

// export default function WhyChooseUs() {
//   return (
//     <div className="py-20 bg-gray-50">
//       <div className="text-center mb-12 max-w-3xl mx-auto">
//         <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Choose Us</h2>
//         <p className="text-gray-600 text-lg">
//           Engineered with a deep understanding of Nepal's dairy needs
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto px-4">
//         <div className="bg-white rounded-xl p-6 shadow-md text-center">
//           <div className="bg-blue-100 p-4 rounded-full inline-block mb-4">
//             <MapPin className="text-blue-600 w-8 h-8" />
//           </div>
//           <h4 className="font-semibold text-gray-800 mb-2">
//             Designed for Nepal
//           </h4>
//           <p className="text-gray-600">
//             Built to meet all needs of the Nepali dairy industry.
//           </p>
//         </div>

//         <div className="bg-white rounded-xl p-6 shadow-md text-center">
//           <div className="bg-purple-100 p-4 rounded-full inline-block mb-4">
//             <Gauge className="text-purple-600 w-8 h-8" />
//           </div>
//           <h4 className="font-semibold text-gray-800 mb-2">
//             Precision & Accuracy
//           </h4>
//           <p className="text-gray-600">
//             Ultrasonic technology with pH and conductivity measurement.
//           </p>
//         </div>

//         <div className="bg-white rounded-xl p-6 shadow-md text-center">
//           <div className="bg-green-100 p-4 rounded-full inline-block mb-4">
//             <ShieldCheck className="text-green-600 w-8 h-8" />
//           </div>
//           <h4 className="font-semibold text-gray-800 mb-2">
//             Rugged & Reliable
//           </h4>
//           <p className="text-gray-600">
//             Stainless steel body with industrial-grade durability.
//           </p>
//         </div>

//         <div className="bg-white rounded-xl p-6 shadow-md text-center">
//           <div className="bg-yellow-100 p-4 rounded-full inline-block mb-4">
//             <SettingsAutomation className="text-yellow-600 w-8 h-8" />
//           </div>
//           <h4 className="font-semibold text-gray-800 mb-2">
//             User-Friendly & Automated
//           </h4>
//           <p className="text-gray-600">
//             IoT-enabled connectivity for seamless data management.
//           </p>
//         </div>

//         <div className="bg-white rounded-xl p-6 shadow-md text-center">
//           <div className="bg-red-100 p-4 rounded-full inline-block mb-4">
//             <BuildingStorefront className="text-red-600 w-8 h-8" />
//           </div>
//           <h4 className="font-semibold text-gray-800 mb-2">
//             Own Service Center
//           </h4>
//           <p className="text-gray-600">
//             Customer service and hassle-free part replacement.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import {
  MapPin,
  Gauge,
  ShieldCheck,
  SettingsAutomation,
  Headset,
} from "tabler-icons-react";

export default function WhyChooseUs() {
  return (
    <div className="py-20 bg-white">
      <div className="text-center mb-12">
        <h3 className="text-3xl font-bold text-gray-900 mb-4">Why Choose Us</h3>
        <p className="text-lg text-gray-600">
          Tailored solutions for the Nepali dairy ecosystem
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto px-4">
        <div className="text-center bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm">
          <div className="bg-red-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <MapPin className="w-8 h-8 text-red-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Designed for Nepal
          </h5>
          <p className="text-gray-600">
            Built to meet all needs of the Nepali dairy industry
          </p>
        </div>

        <div className="text-center bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm">
          <div className="bg-blue-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <Gauge className="w-8 h-8 text-blue-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Precision & Accuracy
          </h5>
          <p className="text-gray-600">
            Ultrasonic technology, pH and conductivity analysis
          </p>
        </div>

        <div className="text-center bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm">
          <div className="bg-green-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <ShieldCheck className="w-8 h-8 text-green-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Rugged & Reliable
          </h5>
          <p className="text-gray-600">
            Stainless steel body with industrial-grade durability
          </p>
        </div>

        <div className="text-center bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm">
          <div className="bg-yellow-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <SettingsAutomation className="w-8 h-8 text-yellow-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            User-Friendly & Automated
          </h5>
          <p className="text-gray-600">
            IoT-enabled connectivity for seamless data management
          </p>
        </div>

        <div className="text-center bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl shadow-sm">
          <div className="bg-purple-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <Headset className="w-8 h-8 text-purple-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Own Service Center
          </h5>
          <p className="text-gray-600">
            Customer support & hassle-free part replacement
          </p>
        </div>
      </div>
    </div>
  );
}
